import { ArrayInput, FormDataConsumer, SimpleFormIterator } from "react-admin";
import Inputs from "./Inputs";

export default function PriceItemForm(props) {
  const onlyPrices = props.onlyPrices;
  return (
    <ArrayInput
      source="price_items"
      label={onlyPrices ? false : undefined}
      defaultValue={
        onlyPrices
          ? [{ buy_price: "", sell_price: "" }]
          : [{
              quality_id: "",
              buy_price: "",
              sell_price: "",
            }]
      }
    >
      <SimpleFormIterator
        getItemLabel={onlyPrices ? undefined : (index) => `#${index + 1}`}
        disableAdd={onlyPrices}
        disableClear={onlyPrices}
        disableRemove={onlyPrices}
        disableReordering={onlyPrices}
        fullWidth
        sx={{
          "& .RaSimpleFormIterator-action, & .RaSimpleFormIterator-action > .button-reorder":
            {
              display: "flex",
              flexDirection: "column",
            },
          "& .RaSimpleFormIterator-line": {
            mt: 2,
          },
        }}
      >
        <FormDataConsumer>
          {(props) => Inputs({ ...props, onlyPrices })}
        </FormDataConsumer>
      </SimpleFormIterator>
    </ArrayInput>
  );
}
